import { KeyboardEventHandler } from 'react';

export const handleKeyDownDefault =
  (params: {
    allowEnterForSelect?: boolean;
    ignore?: boolean;
  }): KeyboardEventHandler<HTMLDivElement> =>
  event => {
    if (params.ignore) {
      return;
    }
    if (event.key === 'Enter' && !params.allowEnterForSelect) {
      event.preventDefault();
    }
  };
